import { render, staticRenderFns } from "./ProductImportDialog.vue?vue&type=template&id=c735cc18&scoped=true"
import script from "./ProductImportDialog.vue?vue&type=script&lang=js"
export * from "./ProductImportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c735cc18",
  null
  
)

export default component.exports